import { IntlShape } from "react-intl";
import React from "react";
import { GameParams } from "../../../validation/game-params";
import { IntlProvider } from "react-intl";

import styles from "./styles.modules.scss";

type TabViewChildProps = {
    locale: LocaleSettings;
    data: unknown;
    userSettings: GameParams;
};

export const TabView = ({
    children: Component,
    data,
    intl,
    locale,
    style,
    userSettings,
}: {
    children: React.ComponentType<TabViewChildProps>;
    data: unknown;
    locale: LocaleSettings;
    userSettings: GameParams;
    style: { [key in string]: string };
    intl: IntlShape;
}) => (
    <div
        className={`tab ${style.direction} ${styles.tab}`}
        style={style}
        lang={locale.lang}
    >
        <IntlProvider {...intl}>
            <Component
                locale={locale}
                data={data}
                userSettings={userSettings}
            />
        </IntlProvider>
    </div>
);
